<div class="mb-3">
  <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
    <input type="text" class="form-control" [formControl]="formControlObj" [name]="detailInfo.title"
      placeholder="Your detailInfo" />
  </app-field-title>
</div>